export default __webpack_public_path__ + "static/physio-stretch-logo-d4e231f407f8a5e8093798d15d4ff9bd.png";